/* Header, compact desktop search and full-screen mobile search. */
(function () {
  'use strict';

  var nav = document.getElementById('nav');
  var burger = document.getElementById('burger');
  var mobileNav = document.getElementById('mnav');
  var searchButton = document.getElementById('searchBtn');
  var compact = document.getElementById('searchCompact');
  var compactForm = document.getElementById('searchCompactForm');
  var compactInput = document.getElementById('searchCompactInput');
  var mobileSearch = document.getElementById('searchMobile');
  var mobileBack = document.getElementById('searchMobileBack');
  var mobileInput = document.getElementById('searchMobileInput');
  var scrolled = false;

  function isMobile() { return window.matchMedia('(max-width:860px)').matches; }
  function setFocusable(container, enabled) {
    if (!container) return;
    container.querySelectorAll('a,button,input,summary,[tabindex]').forEach(function (element) {
      if (enabled) element.removeAttribute('tabindex');
      else element.setAttribute('tabindex', '-1');
    });
  }
  function refreshPageLock() {
    var locked = (mobileNav && mobileNav.classList.contains('is-open')) || (mobileSearch && mobileSearch.classList.contains('is-open'));
    document.documentElement.style.overflow = locked ? 'hidden' : '';
  }
  function refreshNav() {
    if (!nav) return;
    nav.classList.toggle('scrolled', scrolled || (mobileNav && mobileNav.classList.contains('is-open')));
  }
  function onScroll() {
    if (!scrolled && window.scrollY > 64) scrolled = true;
    else if (scrolled && window.scrollY < 16) scrolled = false;
    refreshNav();
  }
  function setHeaderHeight() {
    if (nav) document.documentElement.style.setProperty('--header-h', nav.offsetHeight + 'px');
  }

  if (nav) {
    onScroll();
    setHeaderHeight();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeaderHeight);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderHeight);
  }

  function closeMobileNav(refocus) {
    if (!mobileNav || !burger) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    setFocusable(mobileNav, false);
    burger.setAttribute('aria-expanded', 'false');
    refreshNav();
    refreshPageLock();
    if (refocus) burger.focus();
  }
  function openMobileNav() {
    if (!mobileNav || !burger) return;
    closeMobileSearch(false);
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    setFocusable(mobileNav, true);
    burger.setAttribute('aria-expanded', 'true');
    refreshNav();
    refreshPageLock();
  }
  if (mobileNav && burger) {
    mobileNav.setAttribute('aria-hidden', 'true');
    setFocusable(mobileNav, false);
    burger.addEventListener('click', function () {
      if (mobileNav.classList.contains('is-open')) closeMobileNav(false);
      else openMobileNav();
    });
    mobileNav.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', function () { closeMobileNav(false); }); });
  }

  function closeCompact(refocus) {
    if (!compact || !compactForm) return;
    compact.classList.remove('is-open');
    compactForm.setAttribute('aria-hidden', 'true');
    if (compactInput) compactInput.setAttribute('tabindex', '-1');
    if (searchButton) searchButton.setAttribute('aria-expanded', 'false');
    if (refocus && searchButton) searchButton.focus();
  }
  function openCompact() {
    if (!compact || !compactForm) return;
    compact.classList.add('is-open');
    compactForm.setAttribute('aria-hidden', 'false');
    if (compactInput) {
      compactInput.removeAttribute('tabindex');
      compactInput.focus({ preventScroll: true });
    }
    if (searchButton) searchButton.setAttribute('aria-expanded', 'true');
  }

  function closeMobileSearch(refocus) {
    if (!mobileSearch) return;
    mobileSearch.classList.remove('is-open');
    mobileSearch.setAttribute('aria-hidden', 'true');
    setFocusable(mobileSearch, false);
    if (searchButton) searchButton.setAttribute('aria-expanded', 'false');
    refreshPageLock();
    if (refocus && searchButton) searchButton.focus();
  }
  function openMobileSearch() {
    if (!mobileSearch) return;
    closeMobileNav(false);
    closeCompact(false);
    mobileSearch.classList.add('is-open');
    mobileSearch.setAttribute('aria-hidden', 'false');
    setFocusable(mobileSearch, true);
    if (searchButton) searchButton.setAttribute('aria-expanded', 'true');
    refreshPageLock();
    if (mobileInput) mobileInput.focus({ preventScroll: true });
  }
  if (mobileSearch) {
    mobileSearch.setAttribute('aria-hidden', 'true');
    setFocusable(mobileSearch, false);
  }
  if (searchButton) {
    searchButton.addEventListener('click', function () {
      if (mobileSearch && mobileSearch.classList.contains('is-open')) closeMobileSearch(true);
      else openMobileSearch();
    });
  }
  if (mobileBack) mobileBack.addEventListener('click', function () { closeMobileSearch(true); });
  document.addEventListener('click', function (event) {
    if (!isMobile() && compact && compact.classList.contains('is-open') && !compact.contains(event.target)) closeCompact(false);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (mobileSearch && mobileSearch.classList.contains('is-open')) closeMobileSearch(true);
    else if (mobileNav && mobileNav.classList.contains('is-open')) closeMobileNav(true);
    else closeCompact(true);
  });
  window.addEventListener('resize', function () {
    if (isMobile()) closeCompact(false);
    else closeMobileSearch(false);
  });

  var shopItem = document.querySelector('.nav-tabs-item-shop');
  var megaToggle = document.getElementById('megaToggle');
  var megaMenu = document.getElementById('megaMenu');
  if (shopItem && megaToggle && megaMenu) {
    setFocusable(megaMenu, false);
    var megaOpenTimer, megaCloseTimer;
    function openMega() {
      window.clearTimeout(megaOpenTimer); window.clearTimeout(megaCloseTimer);
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
      megaToggle.setAttribute('aria-expanded', 'true');
      setFocusable(megaMenu, true);
      scrolled = true;
      refreshNav();
    }
    function closeMega() {
      window.clearTimeout(megaOpenTimer); window.clearTimeout(megaCloseTimer);
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
      megaToggle.setAttribute('aria-expanded', 'false');
      setFocusable(megaMenu, false);
      onScroll();
    }
    function scheduleOpenMega() { window.clearTimeout(megaCloseTimer); megaOpenTimer = window.setTimeout(openMega, 120); }
    function scheduleCloseMega() { window.clearTimeout(megaOpenTimer); megaCloseTimer = window.setTimeout(closeMega, 180); }

    shopItem.addEventListener('mouseenter', scheduleOpenMega);
    shopItem.addEventListener('mouseleave', scheduleCloseMega);
    megaMenu.addEventListener('mouseenter', function () { window.clearTimeout(megaCloseTimer); });
    megaMenu.addEventListener('mouseleave', scheduleCloseMega);

    megaToggle.addEventListener('click', function () {
      if (megaMenu.classList.contains('is-open')) closeMega(); else openMega();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && megaMenu.classList.contains('is-open')) {
        closeMega();
        megaToggle.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (megaMenu.classList.contains('is-open') && !megaMenu.contains(event.target) && !shopItem.contains(event.target)) closeMega();
    });
    megaMenu.addEventListener('focusout', function (event) {
      if (!megaMenu.contains(event.relatedTarget) && event.relatedTarget !== megaToggle) closeMega();
    });
    megaMenu.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', closeMega); });
  }
})();
